/** @jsx jsx */
import { jsx } from "@emotion/react";
import { ClickAwayListener, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { Fragment, ReactFragment, ReactNode, useState } from "react";
import { tooltipHeaderCss, TooltipIcon, tooltipParagraphCss } from "./styles";

export type InfoTooltipProps = {
  tooltipTitle: string;
  tooltipText: string;
};

const CustomTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: "#ffffff",
    maxWidth: 200,
    border: "none",
    borderRadius: 7,
    boxShadow: "0 0 2px 1px lightgray",
    padding: "5px 0 2px 0",
    fontFamily: "Fira Sans",
  },
  arrow: {
    color: "#ffffff",
  },
}))(Tooltip);

const InfoTooltip = ({ tooltipTitle, tooltipText }: InfoTooltipProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const closeTooltip = () => setIsOpen(false);

  const toggleTooltip = () => setIsOpen(!isOpen);

  if (!tooltipText) return null;

  return (
    <ClickAwayListener onClickAway={closeTooltip}>
      <span>
        <CustomTooltip
          title={
            // eslint-disable-next-line react/jsx-wrap-multilines
            <Fragment>
              <h1 css={tooltipHeaderCss}>{tooltipTitle}</h1>
              <p css={tooltipParagraphCss}>{tooltipText}</p>
            </Fragment>
          }
          placement="bottom-start"
          arrow
          onClose={closeTooltip}
          open={isOpen}
          disableFocusListener
          disableHoverListener
          disableTouchListener
        >
          <TooltipIcon onClick={toggleTooltip} />
        </CustomTooltip>
      </span>
    </ClickAwayListener>
  );
};

export default InfoTooltip;
